import React, { useState, useEffect } from "react";
import ConnectAPI from "../../../services/api";
import { useTranslation } from "react-i18next";
import {Modal,Select,TextBox,Button, TextArea } from "@veneer/core";
import Swal from "sweetalert2";
import moment from "moment";
import $ from 'jquery';
import { Col, Row } from "react-bootstrap";

const connectApi = new ConnectAPI();
const ModalManualAdjustment = ({ idManualAdjustment, onShowModal, onCloseSCDetailsModal, ManualAdjustmentDetail , confirmationFunction, lastPublication,currentuser}) => {
    const { t, i18n } = useTranslation();
    const [EnduserView, setEnduserView]=useState([]);
    const [Endusers,setEndusers]=useState([]);
    const [channels,setChannels]=useState([]);
    const [channelViewNew, setChannelViewNew] = useState([]);
    const [idChannel, setIdChannel] = useState();
    const [idEndUser, setidEndUser] = useState();
    const [press, setpress]=useState();
    const [bonus, setbonus]=useState("");
    const [creditnote, setcreditnote]=useState("");
    const [compensation, setcompensation]=useState("");
    const [Comments,setComments]=useState("");
    const [activeBonus, setactiveBonus]=useState(true);
    const [activecreditnote, setactivecreditnote]=useState(true);
    const [activecompensation, setactivecompensation]=useState(true);
    const [pressProgram, setpressProgram]=useState("");
    const [pressesView, setpressesView]=useState([]);
    const [enableChannel, setenableChannel]=useState(false);
    const [enableEndUser, setenableEndUser]=useState(false);
    const [enablePress, setenablePress]=useState(false);
    const [enableComments, setenableComments]=useState(false);

    useEffect(() => {
        fetchChannels();
    },[]);
    useEffect(()=>{
        
        if (idManualAdjustment!=0 && idManualAdjustment!=undefined){
            setIdChannel([ManualAdjustmentDetail.idCustomer]);
            fetchEndUsers(ManualAdjustmentDetail.idCustomer);
            fetchPress(ManualAdjustmentDetail.idEndUser);
            setidEndUser([ManualAdjustmentDetail.idEndUser]);
            setpress([ManualAdjustmentDetail.idPress]);
            checkwithoutpress();
            var param={
                'idenduser':ManualAdjustmentDetail.idEndUser,
                'idpress':ManualAdjustmentDetail.idPress,
                'idcustomer':ManualAdjustmentDetail.idCustomer
            }
            if(ManualAdjustmentDetail.status=="Under approval"){
                connectApi.getWithParams("api/Channels/getpressprogram",param , consolid)
                .catch((error) => {
                    Swal.fire(
                        "Error " + error?.response?.status,
                        error?.response?.data,
                        "error"
                    );
                })
            } 
            
            setComments(ManualAdjustmentDetail.comments);
            setbonus(ManualAdjustmentDetail.bonus);
            setcreditnote(ManualAdjustmentDetail.creditNote);
            setcompensation(ManualAdjustmentDetail.compensation);
            if(ManualAdjustmentDetail.status!="Under approval"){
                setenableChannel(true);
                setenableEndUser(true);
                setenablePress(true);
                setenableComments(true);
                setactivecreditnote(true);
                setactiveBonus(true);
                setactivecompensation(true);
            }
        }
    },[ManualAdjustmentDetail]);
    
    
    const fetchEndUsers = (channel) => {
        connectApi.get("api/Channels/endUsers",{
            params:{
                customerId: channel,
                status: "Active",
            }
        },EndUserListData).catch((error) => {
            Swal.fire(
                "Error " + error?.response,
                error?.response,
                "error"
            );
        });
    };
    const PressListData = (status, data) => {
        const items = data.map((item) => {
            
            return{
                value: item.idPress,
                label: item.idPress,
            };
            
        });
        setpressesView(items);
        
    };
    const fetchPress = (endUser) => {
        connectApi
        .get("api/Channels/endUsers/" + endUser + "/ActivePresses",
        {
            params:{
                endUserId: endUser
            }
        },PressListData)
        .catch((error) => {
            console.log(error);
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
              );
        });
    };
    const fetchChannels = async () => {
        connectApi.get('api/Channels', '', dataResponseChannel)
        .catch((error) => {
            Swal.fire(
                "Error " + error.response,
                error.response,
                "error"
            );
        });
    };
    const dataResponseChannel = (status, data) => {
        setChannels(data);
        const items = data.map((item) => {
            if (item.type != "Inactive"){
                return{
                    value: item.idCustomer,
                    label: item.name,
                };
            }
        });
        let channels = items.filter(x => x)
        setChannelViewNew(channels);
    };
    const updateEndusers=(val)=>{
        if (val!=undefined){
            
            fetchPress(val.value);
            setidEndUser([val.value]);
            setactivecreditnote(false);
            setactiveBonus(false);
            setactivecompensation(false);
           
        }
        
    }
    const clearEndUsers=()=>{
        setidEndUser();
        setactivecreditnote(false);
        setactiveBonus(true);
        setactivecompensation(true);
        setpressesView([]);
        setpress();
    }
    const EndUserListData = (status, data) => {
        setEndusers(data);
        const items = data.map((item) => {
            return{
                value: item.idEndUser,
                label: item.endUserName,
            };
        });
        setEnduserView(items);
    };
    const updateListEndUser = (val) => {
        
        setidEndUser(undefined);
        setIdChannel([val.value]);
        fetchEndUsers(val.value);


        setactivecreditnote(false);
        setactiveBonus(true);
        setactivecompensation(true);
    }
    const checkwithoutpress=()=>{
        if ((idEndUser!="" || idEndUser!=undefined ) && (idChannel!="" || idChannel!=undefined)){
            setactivecreditnote(false);
            setactiveBonus(false);
            setactivecompensation(false);
        }
    }
    const clearPresses=()=>{
        setactivecreditnote(false);
        setactiveBonus(false);
        setactivecompensation(false);
        setpress();
    }
    const updatepress=(val)=>{
        setpress([val.value]);
        checkwithoutpress();
        if (val.value!="" && idEndUser!="" && idChannel!=""){
            var param={
                'idenduser':idEndUser[0],
                'idpress':val.value,
                'idcustomer':idChannel[0]
            }
            connectApi.getWithParams("api/Channels/getpressprogram",param , consolid)
            .catch((error) => {
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            })
        }
    }
    const consolid=(status, data)=>{
        
        setpressProgram(data);
        switch (data){
            case "REBATE":
                setactivecreditnote(false);
                setactiveBonus(false);
                setactivecompensation(true);
                break;
            case "COMPENSATION":
                setactivecreditnote(true);
                setactiveBonus(true);
                setactivecompensation(false);
                break;
            case "Not Found":
                setactivecreditnote(true);
                setactiveBonus(true);
                setactivecompensation(true);
                break;
        }
    }
    const submit=()=>{
        let data= new FormData();
        data.append("idCustomer",idChannel);
        data.append("idEnduser",idEndUser);
        data.append("idpress",press);
        data.append("bonus",bonus);
        data.append("creditnote",creditnote);
        data.append("compensation",compensation);
        data.append("comments",Comments);
        if (idManualAdjustment!=0){
            data.append("idManualAdjustment",idManualAdjustment);
        }
        connectApi.post("api/channels/savemanualadjustment",data,savemanualadjustment)
    }
    function send_status(status){
        let data= new FormData();
        data.append("idManualAdjustment",idManualAdjustment);
        data.append("status",status);
        connectApi.post("api/channels/statusmanualadjustment",data,savemanualadjustment)
    }
    const savemanualadjustment=(status, data)=>{
        if (status==200){
            confirmationFunction();
        }
    }
    return(<>
        <Modal
            id="regular-modal"
            onClose={() => { onCloseSCDetailsModal();   }}
            show={onShowModal}
            css={{
                '.vn-modal--content': {
                    width: "800px !important"
                },
                }}
            title="Manual Adjustment"
                
            >
                <Row>
                    <Col>
                        <label>{t('channel')}</label>
                        <Select
                            clearIcon={false}
                            value={idChannel}
                            options={channelViewNew}
                            onChange={val => updateListEndUser(val)}
                            placeholder={t('select_channel')}
                            readOnly={enableChannel}
                        />
                    </Col>
                    <Col>
                        <label>{t('endUserName')}</label>
                        <Select
                            value={idEndUser}
                            onClear={clearEndUsers}
                            options={EnduserView}
                            onChange={val=>updateEndusers(val)}
                            placeholder={t('selectEndUser')}
                            readOnly={enableEndUser}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <label>{t('Presses')}</label>
                        <Select
                            value={press}
                            onClear={clearPresses}
                            onChange={(val)=>updatepress(val)}
                            options={pressesView}
                            readOnly={enablePress}
                        />
                    </Col>
                    <Col>
                        <label>{t('comments')}</label>
                        <TextArea
                            value={Comments}
                            onChange={(val)=>setComments(val)}
                            readOnly={enableComments}
                        />
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col>
                        <label>{t('bonus')}</label>
                        <TextBox
                            value={bonus}
                            disabled={activeBonus}
                            onChange={(val)=>setbonus(val)}
                        />
                    </Col>
                    <Col>
                        <label>{t('credit note')}</label>
                        <TextBox
                            value={creditnote}
                            disabled={activecreditnote}
                            onChange={(val)=>setcreditnote(val)}
                        />
                    </Col>
                    <Col>
                        <label>{t('compensation')}</label>
                        <TextBox
                            value={compensation}
                            disabled={activecompensation}
                            onChange={(val)=>setcompensation(val)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <br/>

                        {(currentuser.idRole==8 && ManualAdjustmentDetail.status=="Under approval")?(
                            <>
                                <Button onClick={() => send_status('Approved')}>Approved</Button>&nbsp;&nbsp;
                                <Button onClick={() => send_status('Rejected')} appearance="secondary">Rejected</Button>
                            </>
                            
                        ):(
                            (idManualAdjustment!=0 && ManualAdjustmentDetail.status=="Under approval")?(
                                (moment(ManualAdjustmentDetail.monthYear).set('date',1).format("DD/MMM/YYYY")<=moment(lastPublication).set('date',1).format("DD/MMM/YYYY"))?(
                                    <Button onClick={submit}>
                                        {t('save_button')}
                                    </Button>
                                ):(
                                    <></>
                                )
                            ):(
                                (idManualAdjustment==0)?(
                                    <Button onClick={submit}>
                                        {t('save_button')}
                                    </Button>
                                ):(
                                    <></>
                                )
                                
                            )
                        )}
                        {}
                        
                    </Col>
                </Row>
            </Modal>
    </>);

}

export default ModalManualAdjustment;
